import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";


export const MenuIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue5d2'}</MuiIcon>
        );
    })